// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2406":"c7f16e09","7083":"c7f16e09","9779":"c7f16e09"}[chunkId] + ".chunk.css";
};